import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { sanitizeEmptyStringValues } from 'lib/sanitizeEmptyStringValues'
import { Form, Input } from 'components/forms'
import { InfoButton } from 'components/buttons'
import { ageNextBirthday } from 'lib/date'
import { ordinalSuffix } from 'lib/format-strings'
import { registryPath } from 'lib/urls'
import { destroyState } from 'lib/session-storage'
import { track, useTracking } from 'lib/analytics'
import Slide from '../slide/slide'
import PhotoUploader from '../photo-uploader'

interface BirthdayCreateProps {
  handleSetUserResponse: (data: any) => void
  onboardingUserData?: any
  onSubmit: (data: any) => Promise<any>
}

const mapUserDataToAttributeData = (userData: any) => ({
  registry: {
    photo_url: userData?.registry?.photo_url,
    registry_attributes_attributes: {
      attribute_data: userData,
      registry_type: 'birthday',
    },
  },
})

const BirthdayCreate = ({
  handleSetUserResponse,
  onboardingUserData,
  onSubmit,
}: BirthdayCreateProps) => {
  let titlePlaceholder = ''
  const tracker = useTracking()

  if (
    onboardingUserData &&
    onboardingUserData.birthdate &&
    onboardingUserData.first_name
  ) {
    const age = ageNextBirthday(onboardingUserData.birthdate)
    titlePlaceholder = `${onboardingUserData.first_name}'s ${ordinalSuffix(
      age
    )} Birthday!`
  }
  const [submitting, setSubmitting] = useState(false)
  const { errors, register, handleSubmit } = useForm({
    defaultValues: {
      registry: {
        title: titlePlaceholder,
      },
    },
  })

  const handlePhotoUpload = (url: string) => {
    handleSetUserResponse({
      ...onboardingUserData,
      registry: {
        ...onboardingUserData.registry,
        photo_url: url,
      },
    })
  }

  const handleCreateRegistry = (data: any) => {
    const finalData = {
      ...data,
      registry: {
        ...data.registry,
        ...mapUserDataToAttributeData(onboardingUserData).registry,
      },
    }
    setSubmitting(true)
    onSubmit(sanitizeEmptyStringValues(finalData))
      .then(({ registry: { id, ownerId, urlSlug } }) => {
        setSubmitting(false)
        destroyState()

        tracker.trackEvent({
          event: track.listCreated,
          eventLocation: track.EventLocation.REGISTRY_CREATE_FORM,
          isRegistryOwner: true,
          listType: track.ListType.BIRTHDAY,
          registryId: id,
          registryOwnerId: ownerId,
        })
        window.location.href = registryPath(urlSlug, { confetti: true })
      })
      .catch((resp) => {
        setSubmitting(false)
        Promise.reject(resp)
      })
  }

  return (
    <Slide title="Let's set up this wishlist.">
      <Form onSubmit={handleSubmit(handleCreateRegistry)}>
        <PhotoUploader
          value={onboardingUserData?.registry?.photo_url}
          onChange={handlePhotoUpload}
        />
        <Input
          error={errors?.registry?.title && errors.registry.title.message}
          inputRef={register({
            required: 'Please enter a title for your wishlist.',
          })}
          label="Title"
          name="registry[title]"
          type="text"
        />
        <Input
          inputRef={register}
          label="Greeting or Party Information (optional)"
          name="registry[description]"
          type="text"
        />

        <InfoButton
          block
          pill
          className="mtl"
          disabled={submitting}
          submitting={submitting}
          type="submit"
        >
          Done
        </InfoButton>
      </Form>
    </Slide>
  )
}

export default BirthdayCreate
